import styled from 'styled-components';
import { CodeAuthIframe } from '@shared/components/CodeAuthIframe';

export const Container = styled(CodeAuthIframe).attrs({
  url: 'login',
})`
  display: flex;
  height: 100%;
`;
